import clsx from "clsx";
import { useEffect } from "react";
import { match } from "ts-pattern";

import { useMenu } from "./MenuContext";

export const MenuTooltip: React.FC<{
  placement?: "top" | "right" | "bottom" | "left";
  children: React.ReactElement;
  tip: string;
  className?: string;
}> = ({ tip, placement = "bottom", children, className = "tooltip" }) => {
  const { isTooltipHidden, isMenuOpen, setIsTooltipHidden } = useMenu();

  useEffect(() => {
    if (isMenuOpen) {
      setIsTooltipHidden(true);
    }
  }, [isMenuOpen, setIsTooltipHidden]);

  return (
    <div
      data-tip={tip}
      className={clsx(
        !isMenuOpen && !isTooltipHidden && className,
        match(placement)
          .with("top", () => "!tooltip-top")
          .with("right", () => "!tooltip-right")
          .with("bottom", () => "!tooltip-bottom")
          .with("left", () => "!tooltip-left")
          .exhaustive(),
      )}
    >
      {children}
    </div>
  );
};
